import https from "./https"
import store from "@/store"

const organization = store.state.general.organization;

const checkin_campaigns = {
  // 簽到活動
  getCheckinCampaigns(merchantId, params) {
    return https.get(
      `admin/organizations/${organization.id}/merchants/${merchantId}/checkin-campaigns`, 
      { params }
    );
  },

  // 簽到活動創建
  createCheckinCampaign(merchantId, params) {
    return https.post(
      `admin/organizations/${organization.id}/merchants/${merchantId}/checkin-campaigns`, 
      params
    );
  },

  getCheckinCampaign(id) {
    return https.get(`admin/organizations/${organization.id}/checkin-campaigns/${id}`);
  },

  updateCheckinCampaign(id, params) {
    return https.put(`admin/organizations/${organization.id}/checkin-campaigns/${id}`, params);
  },

  deleteCheckinCampaign(id) {
    return https.delete(`admin/organizations/${organization.id}/checkin-campaigns/${id}`);
  },
}

export default checkin_campaigns
